/** Champs dynamiques disponibles dans l’éditeur (palette). */
export interface TicketFieldPaletteItem {
  fieldKey: string;
  label: string;
  kind: 'field' | 'separator' | 'custom';
}

export const TICKET_FIELD_PALETTE: TicketFieldPaletteItem[] = [
  { fieldKey: 'entete_etablissement', label: 'En-tête établissement', kind: 'field' },
  { fieldKey: 'code_document', label: 'N° ticket', kind: 'field' },
  { fieldKey: 'date_heure', label: 'Date / heure', kind: 'field' },
  { fieldKey: 'numero_caisse', label: 'N° caisse', kind: 'field' },
  { fieldKey: 'vendeur', label: 'Vendeur', kind: 'field' },
  { fieldKey: 'client', label: 'Client', kind: 'field' },
  { fieldKey: 'lignes_table', label: 'Tableau articles', kind: 'field' },
  { fieldKey: 'sous_total', label: 'Sous-total', kind: 'field' },
  { fieldKey: 'remise', label: 'Remise', kind: 'field' },
  { fieldKey: 'tva', label: 'TVA', kind: 'field' },
  { fieldKey: 'total', label: 'Total', kind: 'field' },
  { fieldKey: 'modes_paiement', label: 'Modes de paiement', kind: 'field' },
  { fieldKey: 'montant_financier', label: 'Montant opération', kind: 'field' },
  { fieldKey: 'motif_financier', label: 'Motif financier', kind: 'field' },
  { fieldKey: 'code_barre_doc', label: 'Code-barres document', kind: 'field' },
  { fieldKey: 'separator', label: 'Ligne de séparation', kind: 'separator' },
  { fieldKey: 'custom_text', label: 'Texte libre', kind: 'custom' },
];

export function newBlockId(): string {
  return `b_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
